import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../hooks/useNotification";
import { useCancelQuotationMutation } from "../../../store/apiSlice/salesApiSlice";
import { ConfirmationModal } from "../../../components/organisms/Modal/confirmationModal";
import { componentWithCondition } from "../../newLayout/page/components/hoc/componentWithConditionCheck";
import { ListActionBurgerMenu } from "../../newLayout/page/components/OptionsForView/ListActionBurgerMenu";

const QuotationAction = ({ selectedOrderId, setSelectedOrder, selectedOrderFromListview }) => {
  const navigate = useNavigate();
  const notify = useNotification();
  const [cancelQuotation, { isLoading: isCancellingQuotation } = {}] =
    useCancelQuotationMutation();

  const [isCancelling, setIsCancelling] = useState(false);

  const handleCreateRedirect = () => {
    navigate("/sales/quotation/create");
  };

  const handleCancelSubmit = async () => {
    try {
      await cancelQuotation({ id: selectedOrderId[0] }).unwrap();
      notify({
        type: "success",
        message: `Quote “${selectedOrderFromListview[0]?.name}” cancelled successfully.`,
      });
      setSelectedOrder([]);
      setIsCancelling(false);
    } catch (error) {
      notify({ type: "error", message: error.data?.detail || "Failed to cancel quotation." });
    }
  };

  const burgerItems = useMemo(
    () => [
      {
        key: "cancel",
        label: "Cancel",
        onClick: () => setIsCancelling(true),
        disabled: selectedOrderId.length !== 1 || isCancellingQuotation,
        title: selectedOrderId.length === 1 ? "" : "Select a single quote to cancel.",
        isLoading: isCancellingQuotation,
        isDanger: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedOrderId.length, isCancellingQuotation],
  );

  return (
    <>
      <li className={`tableButton activeState`}>
        <button onClick={handleCreateRedirect}>Create</button>
      </li>

      <ListActionBurgerMenu items={burgerItems} />

      {isCancelling && (
        <ConfirmationModal
          titleOfModal="Cancel Quotation"
          btnName="Cancel Quote"
          closeModal={() => {
            setIsCancelling(false);
          }}
          handleModalWork={handleCancelSubmit}
          isLoading={isCancellingQuotation}
          description={
            <>
              Are you sure you want to cancel the quotation{" "}
              <strong>{selectedOrderFromListview[0]?.name}</strong>?
            </>
          }
        />
      )}
    </>
  );
};

export const QuotationActionWithCheck = componentWithCondition(QuotationAction);
